import { Metrics } from './groupMicrobiomeAgeResponse';

type ContributionYears = Metrics[number]['contribution_years'];

const MAX_SYMBOLS = 3;

export function calculateMetricSymbols(
  contributionYears: ContributionYears,
): [string, string] {
  const sign = contributionYears > 0 ? '+' : '-';
  const absoluteValue = Math.abs(contributionYears);
  let symbolsCount = 0;

  if (absoluteValue < 1) symbolsCount = 1;
  else if (absoluteValue < 5) symbolsCount = 2;
  else symbolsCount = 3;

  const symbolsShown = [...Array(symbolsCount)].map(() => sign).join('');
  const symbolsLeftover = [...Array(MAX_SYMBOLS - symbolsCount)]
    .map(() => sign)
    .join('');

  return [symbolsShown, symbolsLeftover];
}
